import endpoints from "@config/endpoints";
import { getData, postDataJSON } from "@services/CommonApiService";
import { ServiceReportCodeForChild } from "./NewBornConstants";
import { errorLogger } from "@utils/applicationLogUtils";

export const fetchBabyCriedOptions = async (setNewBornDetailsFormData: any) => {
  try {
    const getBabyCriedOption = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.babyCriedImmediatelyAtBirth});

    const babyCriedOptions = getBabyCriedOption?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        babyCried: {
          ...prevState.babyCried,
          '#options': babyCriedOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchReferredToHigherManagementOptions = async (setNewBornDetailsFormData: any) => {
  try {
    const getReferredOption = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.referredForFurtherManagement});

    const referredOptions = getReferredOption?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        referred: {
          ...prevState.referred,
          '#options': referredOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchChildAdmittedInOptions = async (setNewBornDetailsFormData: any) => {
  try {
    const getChildAdmittedInOption = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.isChildAdmittedInNbsuSncuNicu});

    const childAdmittedInOptions = getChildAdmittedInOption?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        isChildAdmitted: {
          ...prevState.isChildAdmitted,
          '#options': childAdmittedInOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchVisibleBirthDefectSeenOptions = async (setNewBornDetailsFormData: any) => {
  try {
    const getVisibleBirthDefectSeenOptions = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.anyVisibleBirthDefectSeen});

    const visibleBirthDefectSeenOptions = getVisibleBirthDefectSeenOptions?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        birthDefectSeen: {
          ...prevState.birthDefectSeen,
          '#options': visibleBirthDefectSeenOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchTreatedOrReferred = async (setNewBornDetailsFormData: any) => {
  try {
    const getTreatedOrReferredOptions = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.treatedOrReferred});

    const treatedOrReferredOptions = getTreatedOrReferredOptions?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        ifDefectIdentified: {
          ...prevState.ifDefectIdentified,
          '#options': treatedOrReferredOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchBreastFeedingOptions = async (setNewBornDetailsFormData: any) => {
  try {
    const getBreastFeedingOptions = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.breastFeeding});

    const breastFeedingOptions = getBreastFeedingOptions?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        breastFeeding: {
          ...prevState.breastFeeding,
          '#options': breastFeedingOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchMethodOfTreatment = async (setNewBornDetailsFormData: any) => {
  try {
    const getMethodOfTreatmentOptions = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.methodOfTreatment});

    const methodOfTreatmentOptions = getMethodOfTreatmentOptions?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        methodOfTreatment: {
          ...prevState.methodOfTreatment,
          '#options': methodOfTreatmentOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchNevirapineSyrupOptions = async (setNewBornDetailsFormData: any) => {
  try {
    const getNevirapineSyrupOptions = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.isNevirapineSyrupStartedAtBirth});

    const nevirapineSyrupOptions = getNevirapineSyrupOptions?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        isNevirapineSyrupStarted: {
          ...prevState.isNevirapineSyrupStarted,
          '#options': nevirapineSyrupOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchHIVPositive = async (setNewBornDetailsFormData: any) => {
  try {
    const getHIVPositiveOptions = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.hivPositive});

    const HIVPositiveOptions = getHIVPositiveOptions?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    const updatedOptions = includeNotOption(HIVPositiveOptions);
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        isTestedForHIV: {
          ...prevState.isTestedForHIV,
          '#options': updatedOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchDiarrheaTreatment = async (setNewBornDetailsFormData: any) => {
  try {
    const getDiarrheaTreatment = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.diarrheaTreatment});

    const diarrheaTreatmentOptions = getDiarrheaTreatment?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        diarrheaTreatment: {
          ...prevState.diarrheaTreatment,
          '#options': diarrheaTreatmentOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchAEFIReported = async (setNewBornDetailsFormData: any) => {
  try {
    const getAEFIReportedOptions = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.aefiReported});

    const AEFIReportedOptions = getAEFIReportedOptions?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        whetherAefiReported: {
          ...prevState.whetherAefiReported,
          '#options': AEFIReportedOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchHavingPneumonia = async (setNewBornDetailsFormData: any) => {
  try {
    const getHavingPneumoniaOptions = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.havingPneumonia});

    const havingPneumoniaOptionsOptions = getHavingPneumoniaOptions?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        havingPneumonia: {
          ...prevState.havingPneumonia,
          '#options': havingPneumoniaOptionsOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchDeathRelatedInformationOptions = async (setNewBornDetailsFormData: any) => {
  try {
    const getDeathRelatedInformationOptions = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.deathFollowingAefi});

    const deathRelatedInformationOptions = getDeathRelatedInformationOptions?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        deathRelatedInformation: {
          ...prevState.deathRelatedInformation,
          '#options': deathRelatedInformationOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchDeathReasonOtherThanAEFI = async (setNewBornDetailsFormData: any) => {
  try {
    const getDeathReasonOtherThanAEFI = await getData<any[]>(`${endpoints.reasonForDeath}`);

    const deathReasonOtherThanAEFIOptions = getDeathReasonOtherThanAEFI?.data?.map((key: any) => ({
      value: key.new_born_child_death_reason_name,
      label: key.new_born_child_death_reason_name,
      reportId: key.new_born_child_death_reason_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        deathHappenedDueTo: {
          ...prevState.deathHappenedDueTo,
          '#options': deathReasonOtherThanAEFIOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchProbableCauseOfDeath = async (setNewBornDetailsFormData: any, dob: string) => {
  try {
    const getProbableCauseOfDeath = await getData<any[]>(`${endpoints.childProbableCauseOfDeath}/${dob}`);
    const probableCauseOfDeathOptions = getProbableCauseOfDeath?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        probableCauseOfDeath: {
          ...prevState.probableCauseOfDeath,
          '#options': probableCauseOfDeathOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchPlaceOfDeath = async (setNewBornDetailsFormData: any) => {
  try {
    const getPlaceOfDeath = await getData<any[]>(`${endpoints.getPlaceOfDeathForNewBorn}`);

    const placeOfDeathOptions = getPlaceOfDeath?.data?.map((key: any) => ({
      value: key.place_of_death_name,
      label: key.place_of_death_name,
      reportId: key.place_of_death_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        placeOfDeath: {
          ...prevState.placeOfDeath,
          '#options': placeOfDeathOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchHbigVaccination = async (setNewBornDetailsFormData: any) => {
  try {
    const getHbigVaccination = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.hbig});
    setNewBornDetailsFormData((preState:any) => {
      return {
        ...preState,
        hbigVaccination: {
          ...preState.hbigVaccination,
          '#serviceId': getHbigVaccination?.data[0]?.service_id,
        }
      }
    })
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchOpv0 = async (setNewBornDetailsFormData: any) => {
  try {
    const getOpv0 = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.opv0});
    setNewBornDetailsFormData((preState:any) => {
      return {
        ...preState,
        opv0Vaccination: {
          ...preState.opv0Vaccination,
          '#serviceId': getOpv0?.data[0]?.service_id,
        }
      }
    })
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchBcg = async (setNewBornDetailsFormData: any) => {
  try {
    const getBcg = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.bcg});
    setNewBornDetailsFormData((preState:any) => {
      return {
        ...preState,
        bcgVaccination: {
          ...preState.bcgVaccination,
          '#serviceId': getBcg?.data[0]?.service_id,
        }
      }
    })
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchhepB0 = async (setNewBornDetailsFormData: any) => {
  try {
    const gethepB0 = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.hepb0});
    setNewBornDetailsFormData((preState:any) => {
      return {
        ...preState,
        hepB0Vaccination: {
          ...preState.hepB0Vaccination,
          '#serviceId': gethepB0?.data[0]?.service_id,
        }
      }
    })
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchVitaminK = async (setNewBornDetailsFormData: any) => {
  try {
    const getVitaminK = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.vitK});
    setNewBornDetailsFormData((preState:any) => {
      return {
        ...preState,
        vitaminKGiven: {
          ...preState.vitaminKGiven,
          '#serviceId': getVitaminK?.data[0]?.service_id,
        }
      }
    })
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

const includeNotOption = (option:any) => {
   option.push({
    value: "Not Done",
    label: "Not Done",
    serviceId: null,
    reportId: null,
  });
  return option;

}

export const fetchSyphilsTest = async (setNewBornDetailsFormData: any) => {
  try {
    const getSyphlisTestOptions = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.syphilisCurativeCareGiven});

    const syphilisTest = getSyphlisTestOptions?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    const updatedSyphilisTest = includeNotOption(syphilisTest)
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        syphilisTest: {
          ...prevState.syphilisTest,
          '#options': updatedSyphilisTest,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}

export const fetchNacpReferralOptions = async (setNewBornDetailsFormData: any) => {
  try {
    const getNacpReferralOptions = await postDataJSON<any[]>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.referredToNACP});
    const nacpReferralOptions = getNacpReferralOptions?.data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      serviceId: key.service_id,
      reportId: key.report_id
    }),
    );
    setNewBornDetailsFormData((prevState: any) => {
      return {
        ...prevState,
        referredToNacpReferralFacility: {
          ...prevState.referredToNacpReferralFacility,
          '#options': nacpReferralOptions,
        }
      };
    });
  }
  catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error)
  }
}